{
	"nav": {
		"about": "Chi Sono",
		"projects": "Progetti",
		"contact": "Contattami",
		"blog": "Blog"
	},
	"banner": {
		"name": "Francesco Anzalone",
		"title": "Full Stack Software Engineer",
		"badges": {
			"tools": "Creatore di Tool per Developer",
			"ai": "Sviluppo Potenziato da AI",
			"enterprise": "Soluzioni Enterprise"
		},
		"cta": {
			"projects": "Guarda i progetti",
			"contact": "Contattami"
		}
	},
	"about": {
		"title": "Chi sono",
		"text": [
			"Realizzo applicazioni web che risolvono problemi aziendali concreti.",
			"Negli ultimi quattro anni ho re-ingegnerizzato una piattaforma B2B legacy usata dai principali tour operator europei, portando una codebase compatibile solo con IE a un front-end moderno senza interrompere il business che ci gira sopra.",
			"Come freelance ho progettato e consegnato end-to-end una piattaforma di recruiting: front-end Next.js, back-end serverless Node.js, generazione PDF, email transazionali e pipeline CI/CD, senza conservare alcun dato dei candidati. Uno sviluppatore, circa tre mesi.",
			"Ho pubblicato quattro estensioni VS Code con oltre 16.000 installazioni, tutte nate da problemi reali di workflow. Uso quotidianamente tool di sviluppo AI (Claude Code, GitHub Copilot) per produrre codice migliore, più velocemente.",
			"Vivo nel Regno Unito, disponibile per ruoli remoti o ibridi in team software enterprise."
		]
	},
	"projects": {
		"header": "Progetti"
	},
	"services": {
		"title": "Servizi & competenze",
		"items": [
			{
				"title": "Sviluppo Full-Stack",
				"description": "Sviluppo di applicazioni web scalabili con framework moderni (React, Angular, Vue.js) e sistemi backend robusti (Node.js, TypeScript)"
			},
			{
				"title": "Piattaforme B2B Enterprise",
				"description": "Modernizzazione di sistemi legacy e sviluppo di soluzioni enterprise per requisiti aziendali complessi"
			},
			{
				"title": "Developer Tools & Produttività",
				"description": "Creazione di estensioni VS Code e tool di automazione che migliorano l'efficienza del team e ottimizzano i workflow"
			},
			{
				"title": "Sviluppo Potenziato da AI",
				"description": "Uso quotidiano di tool AI (GitHub Copilot, Claude Code, Codex) per accelerare la delivery e migliorare la qualità del codice"
			}
		]
	},
	"techStack": {
		"title": "Stack tecnologico",
		"categories": {
			"frontend": {
				"title": "Frontend",
				"technologies": ["React", "Next.js", "Angular", "Vue.js", "TypeScript", "JavaScript", "HTML5", "CSS3", "SASS", "Tailwind CSS"]
			},
			"backend": {
				"title": "Backend",
				"technologies": ["Node.js", "Express", "REST APIs", "GraphQL"]
			},
			"devops": {
				"title": "DevOps & Strumenti",
				"technologies": ["Git", "GitHub Actions", "Docker", "CI/CD", "Webpack", "Parcel", "npm"]
			},
			"other": {
				"title": "Altro",
				"technologies": ["VS Code Extension API", "Redux", "RxJS", "Jest", "Vitest", "Playwright", "Agile/Scrum"]
			}
		}
	},
	"extensions": {
		"title": "Estensioni VS Code pubblicate",
		"subtitle": "Tool di produttività usati da migliaia di developer in tutto il mondo",
		"stats": {
			"downloads": "Installazioni",
			"openSource": "Open Source",
			"rating": "Rating Medio",
			"extensions": "Estensioni Pubblicate"
		},
		"cta": "Vai al Marketplace"
	},
	"contact": {
		"title": "Contattami",
		"direct": "Preferisci l'email? Contattami direttamente:",
		"form": {
			"name": "Nome",
			"email": "Email",
			"message": "Messaggio",
			"send": "Invia"
		}
	}
}
